import { IconButton } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import FlexView from 'react-flexview/lib'
import CloseIcon from '@material-ui/icons/Close'
import './CoveragePlanCardSlider.scss'
import { SkywatchSlider } from '../../Core/Buttons/SkywatchSlider'
import { FirebaseConfigKey, FirebaseService } from '../../../services/FirebaseService'
import { CentPretty, getEstimatedMilesOptions } from '../../../services/utils'
import { PAYMENT_FEE } from '../../../Constants'
import { SessionService } from '../../../services/SessionService'

export const CoveragePlanCardSlider = ({ isHightlighted, perMileRate, baseRate, onClose, vehiclesDetails, getVehicles, affiliateCode }) => {
  const [value, setValue] = React.useState(vehiclesDetails.length === 1 ? vehiclesDetails[0].estimated_mileage_value : 1000)
  const isAdmin = SessionService.isAdmin()
  const estimateVals = getEstimatedMilesOptions(affiliateCode,isAdmin)
  return (
    <div className={`coverage-plan-slider${isHightlighted ? '-highlighted' : ''}`}>
      {vehiclesDetails.length === 1 ? (
        <>
          <FlexView className="space-between" vAlignContent={'center'}>
            <div className={`text-small bold ${isHightlighted ? 'white' : 'blue'}`}>Select annual mileage: {value} miles</div>
            <CloseIcon onClick={onClose} className={`clickable ${isHightlighted ? 'purplelight' : 'blue'}`} />
          </FlexView>
          <br />
          <SkywatchSlider
            highlighted={isHightlighted}
            min={estimateVals.estimatedMileageOption[0]}
            max={estimateVals.estimatedMileageOption[estimateVals.estimatedMileageOption.length - 1]}
            onValueChange={newValue => setValue(newValue)}
            step={null}
            defaultValue={value}
            marks={estimateVals.estimatedMileageSteperMarks}
          />

          <FlexView className="space-between" vAlignContent={'center'}>
            <div className={`text-small bold ${isHightlighted ? 'white' : 'blue'}`}>
              Monthly quote: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
              {Math.ceil((baseRate + perMileRate * (value / 12) + PAYMENT_FEE).toFixed(2))}
            </div>
          </FlexView>
        </>
      ) : (
        <>
          <FlexView className="space-between margin-bottom-basic " vAlignContent={'center'}>
            <div className={`text-small bold ${isHightlighted ? 'white' : 'blue'}`}>How do we calculate it?</div>
            <CloseIcon onClick={onClose} className={`clickable ${isHightlighted ? 'purplelight' : 'blue'}`} />
          </FlexView>
          {getVehicles().map((vehicle, i) => (
            <FlexView column vAlignContent="center" className="text-tiny margin-bottom-small" key={i}>
              <div className="bold">
                {vehicle.year} {vehicle.make} {vehicle.model}
              </div>
              <div>
                Monthly base fee of
                <span className="number-border small-margin-left">
                  {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
                  {vehicle.fixedPrice.toFixed(2)}
                </span>{' '}
                + [<span className="number-border">{CentPretty(vehicle.perMilePrice)}</span> x{' '}
                <span className="number-border">{Math.ceil(vehicle.estimatedMileage / 12)}</span> estimated monthly miles]
              </div>
            </FlexView>
          ))}
        </>
      )}
    </div>
  )
}
